import React, { useState } from 'react';
import PizZip from 'pizzip';
import Docxtemplater from 'docxtemplater';
import saveAs from 'file-saver';
import extenso from 'extenso';

function formatarData(dataString) {
  const [dia, mes, ano] = dataString.split("/");

  const meses = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ];

  const mesExtenso = meses[parseInt(mes) - 1];

  return `${dia} de ${mesExtenso} de ${ano}`;
}
const ContractForm = () => {
  const [formData, setFormData] = useState({
    nomeCompleto: '',
    rg: '',
    cpf: '',
    endereco: '',
    dataCasamento: '',
    horarioSaida: '',
    valorPacote: '',
    valorEntrada: '',
    valorEntradaExtenso: '',    
    dataAtual: '',
    entradaPaga: false
  });
  const [file, setFile] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const loadTemplateAndGenerateDoc = async () => {
    if (!file) {
      alert('Por favor, selecione um arquivo de template .docx primeiro.');
      return;
    }

    try {
      const arrayBuffer = await file.arrayBuffer();
      const zip = new PizZip(arrayBuffer);
      const doc = new Docxtemplater(zip, {
        paragraphLoop: true,
        linebreaks: true,
      });


      const dataUTC = new Date(formData.dataCasamento);
      const dataBrasil = new Date(dataUTC.getTime() + dataUTC.getTimezoneOffset() * 60000); // Ajusta para o fuso horário local
      
      const dataAtualUTC = new Date();
      const dataAtualBrasil = dataAtualUTC;//new Date(dataAtualUTC.getTime() + dataAtualUTC.getTimezoneOffset() * 60000);

      const dataFormatada = dataBrasil.toLocaleDateString('pt-BR');
      
      console.log(dataAtualBrasil.toLocaleDateString('pt-BR'));
      const dataAtualFormatada = formatarData(dataAtualBrasil.toLocaleDateString('pt-BR'));
      console.log(dataAtualFormatada);

      // Substituição dos placeholders no documento
      doc.setData({
        nomeCompleto: formData.nomeCompleto,
        rg: formData.rg,
        cpf: formData.cpf,
        endereco: formData.endereco,
        dataCasamento: dataFormatada,
        horarioSaida: formData.horarioSaida,
        valorPacote: formData.valorPacote,
        valorEntrada: formData.valorEntrada,
        valorEntradaExtenso : extenso(formData.valorEntrada),    
        dataAtual: dataAtualFormatada,
        entradaPaga: formData.entradaPaga ? 'Foi' : 'Será'
        
      });

      try {
        doc.render();
        const out = doc.getZip().generate({ type: 'blob',
          mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
        //2026-09-05 CONTRATO DE SERVIÇOS Carla Milena Freire
        saveAs(out, formData.dataCasamento+' CONTRATO DE SERVIÇOS '+formData.nomeCompleto+'.docx');
        alert('Documento gerado com sucesso!');
      } catch (renderError) {
        console.error('Erro ao processar o documento:', renderError);
        alert('Erro ao processar o documento. Verifique os placeholders e os dados fornecidos.');
      }
    } catch (error) {
      console.error('Erro ao gerar o documento:', error);
      alert('Ocorreu um erro ao gerar o documento. Verifique o console para mais detalhes.');
    }
  };

  return (
    <div className="p-6 max-w-3xl mx-auto bg-white shadow-md rounded-md">
      <h1 className="text-2xl font-bold mb-4">Formulário de Contrato</h1>
      <div className="space-y-4">
        <div>
          <label className="block font-medium">Nome Completo</label>
          <input
            type="text"
            name="nomeCompleto"
            value={formData.nomeCompleto}
            onChange={handleChange}
            className="w-full p-2 border rounded-md"
          />
        </div>
        <div>
          <label className="block font-medium">RG</label>
          <input
            type="text"
            name="rg"
            value={formData.rg}
            onChange={handleChange}
            className="w-full p-2 border rounded-md"
          />
        </div>
        <div>
          <label className="block font-medium">CPF</label>
          <input
            type="text"
            name="cpf"
            value={formData.cpf}
            onChange={handleChange}
            className="w-full p-2 border rounded-md"
          />
        </div>
        <div>
          <label className="block font-medium">Endereço</label>
          <input
            type="text"
            name="endereco"
            value={formData.endereco}
            onChange={handleChange}
            className="w-full p-2 border rounded-md"
          />
        </div>
        <div>
          <label className="block font-medium">Data do Casamento</label>
          <input
            type="date"
            name="dataCasamento"
            value={formData.dataCasamento}
            onChange={handleChange}
            className="w-full p-2 border rounded-md"
          />
        </div>
        <div>
          <label className="block font-medium">Horário de Saída</label>
          <input
            type="time"
            name="horarioSaida"
            value={formData.horarioSaida}
            onChange={handleChange}
            className="w-full p-2 border rounded-md"
          />
        </div>
        <div>
          <label className="block font-medium">Valor do Pacote (R$)</label>
          <input
            type="number"
            name="valorPacote"
            value={formData.valorPacote}
            onChange={handleChange}
            className="w-full p-2 border rounded-md"
          />
        </div>
        <div>
          <label className="block font-medium">Valor da Entrada (R$)</label>
          <input
            type="number"
            name="valorEntrada"
            value={formData.valorEntrada}
            onChange={handleChange}
            className="w-full p-2 border rounded-md"
          />
        </div>
        <div>
          <label className="flex items-center">
            <input
              type="checkbox"
              name="entradaPaga"
              checked={formData.entradaPaga}
              onChange={handleChange}
              className="mr-2"
            />
            Entrada já foi paga
          </label>
        </div>
        <div>
          <label className="block font-medium">Carregar Template (.docx)</label>
          <input type="file" accept=".docx" onChange={handleFileChange} className="w-full p-2 border rounded-md" />
        </div>
        <button
          onClick={loadTemplateAndGenerateDoc}
          className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
        >
          Gerar Documento
        </button>
      </div>
    </div>
  );
};

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = (e) => {
    e.preventDefault();
    if (username === 'elaine' && password === '828319@eol') {
      onLogin();
    } else {
      alert('Usuário ou senha incorretos!');
    }
  };

  return (
    <div className="p-6 max-w-sm mx-auto bg-white shadow-md rounded-md">
      <h1 className="text-2xl font-bold mb-4">Login</h1>
      <form onSubmit={handleLogin} className="space-y-4">
        <div>
          <label className="block font-medium">Usuário</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="w-full p-2 border rounded-md"
          />
        </div>
        <div>
          <label className="block font-medium">Senha</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full p-2 border rounded-md"
          />
        </div>
        <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600">
          Entrar
        </button>
      </form>
    </div>
  );
};

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  return isAuthenticated ? <ContractForm /> : <Login onLogin={() => setIsAuthenticated(true)} />;
};

export default App;
//export default ContractForm;
